import React from 'react';

import Button from '@amzn/meridian/button';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { type TableDataRow } from 'src/store/updateShiftsPageSlice';

interface DeleteShiftModalProps {
  isOpen: boolean;
  deletionTarget: TableDataRow | undefined;
  onConfirmDelete: () => void;
  onCancelDelete: () => void;
}

export const DeleteShiftModal = ({
  isOpen,
  deletionTarget,
  onConfirmDelete,
  onCancelDelete,
}: DeleteShiftModalProps) => {
  return (
    <Modal open={isOpen} onClose={onCancelDelete} title={`Delete ${deletionTarget?.shiftCode}?`} width="480px">
      <Text>
        Are you sure you want to delete shift <b>{deletionTarget?.shiftCode}</b>? Doing so will remove this shift's
        capacity slots from any configured jobs referencing it. <b>Any configured slots will be permanently lost</b> and
        must be manually re-entered if needed. Existing placements in this shift code will remain. Do you still wish to
        proceed?
      </Text>
      <ModalFooter>
        <Row alignmentHorizontal="end" widths="fit">
          <Button type="secondary" size="small" onClick={onCancelDelete}>
            Cancel
          </Button>
          <Button type="primary" size="small" onClick={onConfirmDelete}>
            Confirm
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};
